import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import config from '../config/config';

const CardSlider = () => {
    const [college, setCollege] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const collegesPerPage = 10;

    const indexOfLastCollege = currentPage * collegesPerPage;
    const indexOfFirstCollege = indexOfLastCollege - collegesPerPage;
    const currentColleges = college.slice(indexOfFirstCollege, indexOfLastCollege);

    const totalPages = Math.ceil(college.length / collegesPerPage);
    const pageNumbers = [...Array(totalPages).keys()].map(num => num + 1);

    useEffect(() => {
        const fetchCardslider = async () => {
            try {
                const response = await axios.get(
                    `${config.API_BASE_URL}/api/admin/get_cardslider`
                );
                const fetchedData = response.data.allCardslider || [];
                setCollege(fetchedData);
                console.log("fetchedData", fetchedData); // Log for debugging
            } catch (error) {
                console.error("Error fetching college data:", error);
            }
        };

        fetchCardslider();
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this slider?")) {
            try {
                const response = await axios.delete(
                    `${config.API_BASE_URL}/api/admin/delete_slider/${id}`
                );
                if (response.status === 200) {
                    alert(response.data.message);
                    // Update the state to remove the deleted college
                    setCollege((prevData) => prevData.filter((college) => college._id !== id));
                }
            } catch (error) {
                console.error("Error deleting slider:", error);
                alert("Failed to delete the slider. Please try again.");
            }
        }
    };

    return (
        <div>
            <div className="container mt-5 pt-5">
                <div className="row">
                    <div className="col-lg-2"></div>
                    <div className="col-lg-10">
                        <div className="row m-2">

                            <div className="col-6">
                                <h1 className='dashboard_heading'>Card Slider</h1>
                            </div>
                            <div className="col-6">
                                <Link to="/admin/add_cardslider" className="btn btn-success float-end">
                                    Add Card Slider
                                </Link>
                            </div>
                        </div>
                        <div className="row p-3">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>College Name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentColleges.map((item) => (
                                        <tr key={item._id}>
                                            <td>{item.cardName}</td>
                                            <td>
                                                <Link
                                                    to={`/admin/edit_cardslider/${item._id}`}
                                                    className="btn btn-primary mr-2"
                                                >
                                                    Edit
                                                </Link>
                                                <button
                                                    className="btn btn-danger"
                                                    onClick={() => handleDelete(item._id)}
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* <div className="d-flex justify-content-center mt-4">
                                            <ul className="pagination">
                                                {pageNumbers.map((number) => (
                                                    <li key={number} className={`page-item ${number === currentPage ? 'active' : ''}`}>
                                                        <button className="page-link" onClick={() => setCurrentPage(number)}>
                                                            {number}
                                                        </button>
                                                    </li>
                                                ))}
                        </ul>
                    </div> */}
                    <div className="d-flex justify-content-center mt-4">
                        <ul className="pagination flex-wrap">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>Previous</button>
                            </li>

                            {pageNumbers
                                .filter((number) =>
                                    number === 1 ||
                                    number === totalPages ||
                                    (number >= currentPage - 2 && number <= currentPage + 2)
                                )
                                .map((number, index, array) => {
                                    const prev = array[index - 1];
                                    const showDots = index > 0 && number !== prev + 1;

                                    return (
                                        <React.Fragment key={number}>
                                            {showDots && (
                                                <li className="page-item disabled">
                                                    <span className="page-link">...</span>
                                                </li>
                                            )}
                                            <li className={`page-item ${number === currentPage ? 'active' : ''}`}>
                                                <button className="page-link" onClick={() => setCurrentPage(number)}>
                                                    {number}
                                                </button>
                                            </li>
                                        </React.Fragment>
                                    );
                                })}

                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CardSlider;
